import React, { useEffect, useRef, useState } from "react";
import { SelectUser } from "../../../../store/usersSlice";
import { useSelector } from "react-redux";

const Message = ({ message, users }) => {
  const currentUser = useSelector(SelectUser);

  const ref = useRef();

  useEffect(() => {
    ref.current?.scrollIntoView({ behavior: "smooth" });
  }, [message]);

  const [userName, setUserName] = useState("");

  useEffect(() => {
    const filteredUserName = users.find(
      (item) => item.uid === message.senderId
    );
    setUserName(
      filteredUserName.profile.firstName +
        " " +
        filteredUserName.profile.lastName
    );
  }, []);

  
  const milliseconds =
    message.date.seconds * 1000 + Math.floor(message.date.nanoseconds / 1e6);
  const dateObject = new Date(milliseconds);

  const hours = dateObject.getUTCHours();
  const minutes = dateObject.getUTCMinutes();

  const time = `${hours.toString().padStart(2, "0")}:${minutes
    .toString()
    .padStart(2, "0")}`;

  console.log("timetimetime", time);

  return (
    <div
      ref={ref}
      className={`message ${
        message.senderId === currentUser.uid ? "sent" : "received"
      }`}
      style={{
        alignSelf:
          message.senderId === currentUser.uid ? "flex-end" : "flex-start",
      }}
    >
      <div className="message-bubble">
        <div className="sender-info">
          <span className="sender-name">{userName}</span>
          <span className="message-timestamp">{time}</span>
        </div>
        <div className="message-text">{message.text}</div>
      </div>
    </div>
  );
};

export default Message;
